import { BuildRulesetQuery } from '../../../interfaces/Rulesets';
import { extractJsonFieldSql } from '../../extractJsonFieldSql';

export const selectFields_AM_PD_BFV: string = `
3 as rank,
id,
label,
attributes
`;

export const order_AM_PD_BFV  = 'rank DESC, label';

const getAttributes = (rawName: string) => ({
    cv: `$.148.${rawName}`,
    dpmax: `$.417.${rawName}`,
    dn: `$.880.${rawName}`,
});

export const buildQuery_AM_PD_BFV: BuildRulesetQuery = ({
    selectFields,
    rawName,
    filter,
    volumetricFlow,
    kvs,
}): [string, string[]] => {

    const attrs = getAttributes(rawName);
    return [
        `WITH products_filtered as (SELECT
                       cast(cvAttr.value as float) as cv,
                       cast(dpmaxAttr.value as float) as dpmax,
                       cast(dnAttr.value as float) as dn,
                       product.id,
                       label,
                       attributes
                    FROM product
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.cv}`)}) as cvAttr
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.dpmax}`)}) as dpmaxAttr
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.dn}`)}) as dnAttr
                    WHERE ${filter})
            , user_input as (SELECT cast(? as float) as v100, cast(? as float) as cv)
            , bounds as (SELECT
                             cast(floor(cv * 0.89 * 10) as float) / 10 as lower,
                             round(cv * 3, 1) as upper,
                             v100,
                             cv
                         FROM user_input)
            SELECT
                ${selectFields}
                       FROM products_filtered
                       JOIN bounds
                       WHERE products_filtered.cv between bounds.lower and bounds.upper
                       AND CASE WHEN bounds.v100 > 0 AND  dpmax > 0
                           THEN pow(bounds.v100 / products_filtered.cv, 2) <= dpmax
                           ELSE true END 
                       AND CASE WHEN bounds.v100 > 0
                           THEN CASE
                                WHEN substr(label, -3) = 'VIC' THEN (0.4085 * bounds.v100) / pow(products_filtered.dn, 2) <= 20 
                                WHEN substr(label, -3) = 'SHP' THEN (0.4085 * bounds.v100) / pow(products_filtered.dn, 2) <= 32 
                                WHEN substr(label, -3) = 'HDU' THEN (0.4085 * bounds.v100) / pow(products_filtered.dn, 2) <= 12 
                                WHEN substr(label, -2) = 'HD' THEN (0.4085 * bounds.v100) / pow(products_filtered.dn, 2) <= 12 
                                WHEN substr(label, -2) = 'LU' THEN (0.4085 * bounds.v100) / pow(products_filtered.dn, 2) <= 12 
                                WHEN substr(label, -1) = 'L' THEN (0.4085 * bounds.v100) / pow(products_filtered.dn, 2) <= 12 
                                ELSE false END
                           ELSE true END 
        `,
        [volumetricFlow, kvs]
    ];
}



